/** Multi-accounting (ADR-0044): one person, one profile — the link signals, the refused payout, the staff review. */
export default {
  signal: {
    same_person: "same person",
    same_document: "same KYC document",
    same_device: "same device",
    same_fingerprint: "same browser fingerprint",
    same_wallet: "same payout wallet",
    same_email: "same mailbox (e-mail alias)",
    shared_ip: "same network",
  },
  trader: {
    refused: "Payout refused: this profile is linked to another profile with a challenge or funded account (one person — one profile). The request is with our team for review; buying, trading and resets keep working.",
    historyReason: "multi-accounting",
  },
  queue: {
    refused: "Refused — multi-accounting",
    live: "Linked to {n} profile(s) with program accounts",
    overridden: "Multi-accounting overridden: {reason}",
    upheld: "Refusal upheld: {reason}",
    reviewTitle: "Review the refusal",
    reasonLabel: "Written reason (required)",
    reasonHint: "At least 10 characters — for example, a family sharing one computer.",
    override: "Override and return to queue",
    uphold: "Uphold refusal",
    cancel: "Cancel",
    review: "Review",
  },
  view: {
    tab: "Multi-accounts",
    title: "Linked profiles",
    lead: "Profiles that share a device, a KYC document, a payout wallet or a mailbox — or a browser fingerprint together with a network. A payout of a profile linked to another with a challenge or funded account is refused automatically; staff review it in Payouts.",
    hints: "Show weak links too (network or fingerprint alone)",
    empty: "No linked profiles.",
    members: "Profiles",
    pairs: "Links",
    blocking: "blocks payouts",
    hint: "hint only",
    accounts: "Accounts",
    noAccounts: "no program accounts",
    refused: "{n} refused payout(s) waiting",
    paid: "{n} paid",
    since: "since {at}",
  },
};
